import AccordionItem from './AccordionItem'
export default AccordionItem
